import { Component } from '@angular/core';

@Component({
  selector: 'csgofast-ddos-modal',
  templateUrl: './ddos-modal.component.html',
  styleUrls: ['./ddos-modal.component.scss'],
})
export class DdosModalComponent {}
